export default new window.OpenInstall({
    appKey: 'lxn4bd',
    preferWakeup: true,
    onready: function () {
    }
}, window.OpenInstall.parseUrlParams());
